import {Component, EventEmitter, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit{
  item: any = null;
  message?: string;
  action = new EventEmitter<any>();
  language: any = {}

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
  }

  accept(){
    this.action.emit(this.item);
    this.bsModalRef.hide();
  }
}
